<template>
  <div>
    <h1 class="titleprimary">
      <span class="titlecolorized">Inclus dans</span>
      <span class="titlenoncolorized"> Nos Offres</span>
    </h1>
    <div class="columns">
      <div class="column collingForFourColumn">
        <img
          class="imageClassforIntrod"
          src="../assets/imgused/enligne.png"
          alt=" Déclaration médicale en ligne, certificat d'adhésion et délégation
          d'assurance immédiat."
          width="140"
          height="140"
        />
        <h2 class="introClass">En Ligne</h2>
        <p>
          Déclaration médicale en ligne, certificat d'adhésion et délégation
          d'assurance immédiat.
        </p>
      </div>
      <!-- /.col-lg-4 -->
      <div class="column collingForFourColumn">
        <img
          class="imageClassforIntrod"
          src="../assets/imgused/simple.png"
          alt="Aucune formalité médicale jusqu'à 1 000 000€ et 45 ans."
          width="140"
          height="140"
        />
        <h2 class="introClass">Simple</h2>
        <p>Aucune formalité médicale jusqu'à 1 000 000€ et 45 ans.</p>
      </div>
      <!-- /.col-lg-4 -->
      <div class="column collingForFourColumn">
        <img
          class="imageClassforIntrod"
          src="../assets/imgused/rapide.png"
          alt="Un processus d'adhésion rapide et fluide entièrement dématérialisé."
          width="140"
          height="140"
        />
        <h2 class="introClass">Rapide</h2>
        <p>
          Un processus d'adhésion rapide et fluide entièrement dématérialisé.
        </p>
      </div>
      <!-- /.col-lg-4 -->
    </div>
  </div>
</template>

<script>
export default {
  name: "IntroductionEmprunteur",
};
</script>